module.exports = __webpack_public_path__ + "img/totalRevenue.6c9a749e.png";